"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Engine = void 0;
var tslib_1 = require("tslib");
var EntityManager_1 = require("../ecs/EntityManager");
var signal_1 = require("@yoieh/signal");
var Engine = /** @class */ (function () {
    function Engine() {
        this.onSystemAdded = new signal_1.Signal();
        this.onSystemRemoved = new signal_1.Signal();
        this._lastDeltaTime = 0;
        this.systems = [];
        this.systemsToDestroy = [];
        this.entityManager = EntityManager_1.EntityManager.instance;
    }
    Object.defineProperty(Engine.prototype, "lastDeltaTime", {
        get: function () {
            return this._lastDeltaTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Engine, "instance", {
        get: function () {
            if (!Engine._instance) {
                Engine._instance = new Engine();
            }
            return Engine._instance;
        },
        enumerable: false,
        configurable: true
    });
    Engine.prototype.tick = function (deltaTime) {
        this._lastDeltaTime = deltaTime;
        this.update(deltaTime);
        this.cleanUp();
    };
    Engine.prototype.update = function (deltaTime) {
        var e_1, _a;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for (var _b = (0, tslib_1.__values)(this.systems), _c = _b.next(); !_c.done; _c = _b.next()) {
                var system = _c.value;
                if (system.enabled) {
                    system.onUpdate(deltaTime);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Engine.prototype.render = function () {
        var e_2, _a;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for (var _b = (0, tslib_1.__values)(this.systems), _c = _b.next(); !_c.done; _c = _b.next()) {
                var system = _c.value;
                if (system.enabled) {
                    system.onRender(this._lastDeltaTime);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    Engine.prototype.cleanUp = function () {
        var e_3, _a;
        var _loop_1 = function (system) {
            system.onDestroy(this_1._lastDeltaTime);
            this_1.systems = this_1.systems.filter(function (s) { return s !== system; });
        };
        var this_1 = this;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for (var _b = (0, tslib_1.__values)(this.systemsToDestroy), _c = _b.next(); !_c.done; _c = _b.next()) {
                var system = _c.value;
                _loop_1(system);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        this.systemsToDestroy = [];
    };
    Engine.prototype.createSystem = function (system) {
        var newSystem = new system();
        newSystem.onCreate(this._lastDeltaTime);
        this.registerSystem(newSystem);
        return newSystem;
    };
    Engine.prototype.registerSystem = function (system) {
        this.systems.push(system);
        this.onSystemAdded.dispatch(system);
    };
    Engine.prototype.unregisterSystem = function (system) {
        this.systemsToDestroy.push(system);
        this.onSystemRemoved.dispatch(system);
    };
    return Engine;
}());
exports.Engine = Engine;
exports.default = Engine;
